"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typeof_1 = __importDefault(require("./typeof"));

var instanceof_1 = __importDefault(require("./instanceof"));

var range_1 = __importDefault(require("./range"));

var exclusiveRange_1 = __importDefault(require("./exclusiveRange"));

var regexp_1 = __importDefault(require("./regexp"));

var transform_1 = __importDefault(require("./transform"));

var uniqueItemProperties_1 = __importDefault(require("./uniqueItemProperties"));

var allRequired_1 = __importDefault(require("./allRequired"));

var anyRequired_1 = __importDefault(require("./anyRequired"));

var oneRequired_1 = __importDefault(require("./oneRequired"));

var patternRequired_1 = __importDefault(require("./patternRequired"));

var prohibited_1 = __importDefault(require("./prohibited"));

var deepProperties_1 = __importDefault(require("./deepProperties"));

var deepRequired_1 = __importDefault(require("./deepRequired"));

var dynamicDefaults_1 = __importDefault(require("./dynamicDefaults"));

var select_1 = __importDefault(require("./select")); // TODO type


var ajvKeywords = {
  typeof: typeof_1.default,
  instanceof: instanceof_1.default,
  range: range_1.default,
  exclusiveRange: exclusiveRange_1.default,
  regexp: regexp_1.default,
  transform: transform_1.default,
  uniqueItemProperties: uniqueItemProperties_1.default,
  allRequired: allRequired_1.default,
  anyRequired: anyRequired_1.default,
  oneRequired: oneRequired_1.default,
  patternRequired: patternRequired_1.default,
  prohibited: prohibited_1.default,
  deepProperties: deepProperties_1.default,
  deepRequired: deepRequired_1.default,
  dynamicDefaults: dynamicDefaults_1.default,
  select: select_1.default
};
exports.default = ajvKeywords;
module.exports = ajvKeywords;